export var Name = 'product-data-loaded';
export var ProductDataLoadedEvent = Name;